import {CompetitionTablesState, StandingsBySeasonGroupAction} from './types';
import {
  MATCHDETAIL_CLEANUP,
  STANDINGS_BY_SEASON_GROUP_GET_INVALIDATE,
  STANDINGS_BY_SEASON_GROUP_GET_REQUEST,
  STANDINGS_BY_SEASON_GROUP_GET_RESPONSE,
} from '../actionTypes';
import {MatchDetailCleanup} from '../matchDetail/types';

const initialState: CompetitionTablesState = {
  isFetching: false,
  didInvalidate: false,
};

/**
 * Derives the 'competitionTables' state by reducing a new one every time an involved action is dispatches.
 * If the action is not involved (meaning it's not related with this state), then the state
 * is not changed.
 * @param state
 * @param action
 */
const competitionTablesReducer = (state: CompetitionTablesState = initialState, action: StandingsBySeasonGroupAction | MatchDetailCleanup): CompetitionTablesState => {
  switch (action.type) {
    case STANDINGS_BY_SEASON_GROUP_GET_REQUEST:
      return ({
        ...state,
        isFetching: true,
        error: undefined,
      });
    case STANDINGS_BY_SEASON_GROUP_GET_RESPONSE:
      return ({
        ...state,
        isFetching: false,
        didInvalidate: false,
        data: action.payload.competitionTables,
      });
    case STANDINGS_BY_SEASON_GROUP_GET_INVALIDATE:
      return ({
        ...state,
        isFetching: false,
        didInvalidate: true,
        error: action.error,
      });
    case MATCHDETAIL_CLEANUP:
      return ({...initialState});
    default:
      return state;
  }
};

export default competitionTablesReducer;
